import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAlbumsList } from "./MeldiDhamCRUD";
import { useTranslation } from "react-i18next";
import ElementPage from "../Elements";

const GalleryPage = () => {
  const [albumData, setAlbumData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const pathUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    setLoading(true);
    fetchAlbums();
  }, []);

  const fetchAlbums = async () => {
    try {
      const res = await getAlbumsList();
      if (res.data.isSuccess) {
        const activeAlbums = res.data.responseObject.filter(
          (album) => album.isActive
        );
        setAlbumData(activeAlbums);
      }
    } catch (err) {
      console.error("Album fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAlbumClick = (album) => {
    navigate("/page/gallery&album/" + album.albumID, {
      state: {
        albumId: album.albumID,
        albumTitle: getLocalized(album, "albumName"),
      },
    });
  };

  const getLocalized = (item, field) => {
    const lang = i18n.language;
    if (lang === "gu") return item[`${field}_GJ`] || item[field];
    if (lang === "hi") return item[`${field}_HN`] || item[field];
    if (lang === "en") return item[`${field}_EN`] || item[field];
    return item[field];
  };

  return (
    <>
      <div className="w-full py-3">
        <h3
          className="mt-1"
          style={{
            fontSize: "2.3rem",
            textAlign: "center",
            color: "#4c934c",
            letterSpacing: "0.1rem",
          }}
        >
          {t("gallery_page.title", "Gallery Album")}
          <div className="w-16 h-1 bg-[#4c934c] mx-auto mt-2" />
        </h3>
      </div>

      <div className="container py-2">
        <div className="row">
          {loading ? (
            <p className="text-center">Loading albums...</p>
          ) : albumData.length > 0 ? (
            albumData.map((album) => (
              <div
                key={album.albumID}
                className="col-12 col-md-4 col-lg-4 mb-4"
              >
                <div className="card p-3 shadow-sm cursor-pointer">
                  <div onClick={() => handleAlbumClick(album)}>
                    <img
                      src={
                        pathUrl + album.albumPath || "/assets/img/no-image.jpg"
                      }
                      alt={getLocalized(album, "albumName")}
                      className="card-img-top img-fluid"
                      style={{
                        height: "280px",
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <div className="card-body text-center">
                      <p className="fs-5 text-[#4c934c]">
                        {getLocalized(album, "albumName")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              className="col-12 d-flex flex-column justify-content-center align-items-center text-center"
              style={{ minHeight: "80px" }}
            >
              <p className="fs-6 text-muted">{t("no_data")}</p>
              <img
                src="/assets/logo/15-dark.png"
                alt={t("no_data")}
                // height={25}
                width={55}
              />
            </div>
          )}
        </div>
      </div>

      <ElementPage />
    </>
  );
};

export default GalleryPage;
